<template>
    <div class="container-auction">
        <h2>Auction House</h2>
        <ul class="list-day">
            <li class="item-list-day" v-for="(day) in days">
                <div class="active">
                    <div class="day">
                        <span class="title-day" :class="showDay[day] ? 'arrow-down' : 'arrow-right'">
                            {{ ucFirst(day) }}
                            <a href="#!" @click.stop="selectAllNone(day, false)">None</a>
                            <a href="#!" @click.stop="selectAllNone(day, true)">All</a>
                        </span>
                    </div>
                    <ul class="list-auctions" :id="'list-auction-'+day">
                        <template v-for="auction in auctions">
                            <li v-if="auction['show_' + day]" class="item-list-auction">
                                <div class="auction-detail">
                                    <input type="checkbox"
                                           :key="auction.id+'-'+day"
                                           :id="getId(auction.id+'-'+day)"
                                           :value="auction.id"
                                           @change="onChange"
                                           v-model="selectedAuctions[day]">

                                    <label :for="getId(auction.id+'-'+day)">
                                        {{auction.auc_name}}
                                    </label>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {numberWithCommas, searchDataFromModel} from "../../util/common";
    import moment from 'moment'
    export default {
        props: ['value'],
        created(){
            this.getAuctions();
            this.parseInput();
        },
        data() {
            return {
                showDay: {
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    sunday: false,
                },
                days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
                selectedAuctions: {
                    monday: [],
                    tuesday: [],
                    wednesday: [],
                    thursday: [],
                    friday: [],
                    saturday: [],
                    sunday: [],
                }
            }
        },
        computed: {
            ...mapState({
                auctions: state => state.saved_searches.auctions,
            }),
        },
        methods: {
            ...mapActions({
                maybeGetAuctions: 'saved_searches/maybeGetAuctions',
            }),
            ucFirst(string){
                if (string && typeof string === 'string') {
                    return string.charAt(0).toUpperCase() + string.slice(1)
                }
                return ''
            },
            onChange(){
                this.$emit('input', this.selectedAuctions)
            },
            getId(name){
                return `auction_${this._uid}_${name}`;
            },
            parseInput(){
                if (this.value) {
                    this.value.forEach(auc => {
                        this.days.forEach(day => {
                            if (auc.pivot[`show_${day}`]) {
                                this.selectedAuctions[day].push(auc.id)
                            }
                        })
                    })
                    this.onChange()
                }
            },
            selectAllNone(day, select) {
                let selected = [];
                if (select) {
                    this.auctions.forEach(auc => {
                        selected.push(auc.id)
                    });
                }
                this.selectedAuctions[day] = selected
            },
            async getAuctions(){
                try{
                    let auctions = await this.maybeGetAuctions();
                } catch (e) {
                    console.warn(e);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/SavedSearch/SearchAuctions.vue